/* Fromat: {  culture-code: localization-json } */
export default {
    "zh-Hant": require('./zh-Hant.json'),
    "en-US": require('./en-US.json')
}